import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card  } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
    
    root: {
     display:'flex',
     flexDirection: 'column',
     flex:1,
    },
    gridContainerOuter:{
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner:{
        padding : '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    heading: {
        fontSize: 15,
        fontWeight: 'bold',
        flexBasis: '33.33%',
        flexShrink: 0,
      },
      secondaryHeading: {
        color: theme.palette.text.secondary,
      },
}));

function ExpansionComp() {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

    return (
        <div className={classes.root}>
        <div className={classes.titleDiv}>
            <Typography variant="h2">Expansion Panel- Accordian</Typography>
        </div>
        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12}  className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                          Expansion Panel
                        </Typography>
                    </div>
                    <div className={classes.divContent}>
                    
                      <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
          <Typography className={classes.heading}>What is React</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography>
              React is a JavaScript library created by Facebook

              React is a User Interface (UI) library

              React is a tool for building UI components
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
                      
                      <ExpansionPanel>
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                        <Typography className={classes.heading}>What is Babel</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <Typography>
                            Babel is a JavaScript compiler that can translate markup or programming languages into JavaScript.

                            With Babel, you can use the newest features of JavaScript (ES6 - ECMAScript 2015).

                            Babel is available for different conversions. React uses Babel to convert JSX into JavaScript.
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                            
                      <ExpansionPanel>
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel3a-content"
                          id="panel3a-header"
                        >
                        <Typography className={classes.heading}>What is JSX</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <Typography>
                            JSX stands for JavaScript XML.

                            JSX is an XML/HTML like extension to JavaScript.
                            JSX is a XML syntax extension to JavaScript that also comes with the full power of ES6 (ECMAScript 2015).

                            Just like HTML, JSX tags can have a tag names, attributes, and children. If an attribute is wrapped in curly braces, the value is a JavaScript expression.
                                      
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                            
                    </div>
                </Card>
            </Grid>
            
        </Grid>

        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12}  className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                          Controlled Accordion
                        </Typography>
                    </div>

                    <div className={classes.divContent}>

                    <ExpansionPanel expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>What is React</Typography>
          <Typography className={classes.secondaryHeading}>  React is a JavaScript library created...</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            React is a JavaScript library created by Facebook

            React is a User Interface (UI) library

            React is a tool for building UI components
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      
                    <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        <Typography className={classes.heading}>What is Babel</Typography>
                        <Typography className={classes.secondaryHeading}>
                          Babel is a JavaScript compiler that can...
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <Typography>
                          Babel is a JavaScript compiler that can translate markup or programming languages into JavaScript.

                          With Babel, you can use the newest features of JavaScript (ES6 - ECMAScript 2015).

                          Babel is available for different conversions. React uses Babel to convert JSX into JavaScript.
                        </Typography>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    
                    <ExpansionPanel expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography className={classes.heading}>What is JSX</Typography>
                        <Typography className={classes.secondaryHeading}>
                          JSX is an XML/HTML like extension...
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <Typography>
                          JSX stands for JavaScript XML.

                          JSX is an XML/HTML like extension to JavaScript.
                          JSX is a XML syntax extension to JavaScript that also comes with the full power of ES6 (ECMAScript 2015).

                          Just like HTML, JSX tags can have a tag names, attributes, and children. If an attribute is wrapped in curly braces, the value is a JavaScript expression.
                                    
                        </Typography>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                      
                    </div>
                </Card>
            </Grid>
            
        </Grid>

    </div>

    )
}

export default ExpansionComp
